export default class EchoHelper {
    static convertToISODate(dateStr) {
        if (!dateStr)
            return '';

        const parts = dateStr.split('.');
        if (parts.length !== 3)
            return '';

        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

    static convertFromISODate(isoDate) {
        if (!isoDate)
            return '';

        const date = new Date(isoDate);

        return date.toLocaleDateString('ro-RO', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    static parseToDate(value) {
        if (!value) return null;

        // Date object
        if (value instanceof Date) return isNaN(value) ? null : value;

        const s = String(value).trim();

        // ISO: YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            const d = new Date(s + "T00:00:00");
            return isNaN(d) ? null : d;
        }

        // RO: DD.MM.YYYY
        if (/^\d{2}\.\d{2}\.\d{4}$/.test(s)) {
            const iso = EchoHelper.convertToISODate(s);
            const d = new Date(iso + "T00:00:00");
            return isNaN(d) ? null : d;
        }

        // fallback (dd/mm/yyyy etc.)
        const d = new Date(s);
        return isNaN(d) ? null : d;
    }

    static nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    static onDigitInputsChange(event) {
        if (event.ctrlKey) return;
        if (event.charCode != 0 && (event.which < 48 || event.which > 57) &&
            event.charCode != 46 && event.charCode != 44) {
            event.preventDefault();
            return null;
        }
    }

    static handleGradChange(event) {
        const checkbox = event.target;
        const group = checkbox.name;
        document.querySelectorAll(`input[name="${group}"]`).forEach(cb => {
            if (cb !== checkbox) {
                cb.checked = false;
            }
        });
    }
    // Add your BSA calculation logic here
    static calculateBSA(greutate, inaltime) {
        //return Math.round( 0.007184 * Math.pow(greutate,0.425) *  Math.pow(inaltime,0.725) * 100) / 100;
        return Math.round(0.016667 * Math.sqrt(greutate * inaltime) * 100) / 100;
    }
}